import React, { Component } from 'react';
import { Experience } from '../types/Experience';
import * as Icons from 'lucide-react';
interface ExperienceListItemProps {
  experience: Experience;
  isSelected: boolean;
  onClick: () => void;
}
export function ExperienceListItem({
  experience,
  isSelected,
  onClick
}: ExperienceListItemProps) {
  const IconComponent = experience.icon ? (Icons as any)[experience.icon] || Icons.Wine : Icons.Wine;
  return <button onClick={onClick} className="w-full flex items-center gap-3 py-3 px-4 text-left transition-colors border-b border-gray-100 last:border-0" style={{
    backgroundColor: isSelected ? '#FFF5F7' : 'transparent',
    opacity: experience.locked ? 0.5 : 1
  }} data-id="element-120">
      <IconComponent size={18} style={{
      color: experience.locked ? '#9CA3AF' : '#6C083B'
    }} strokeWidth={1.5} data-id="element-121" />
      <div className="flex-1 min-w-0" data-id="element-122">
        <h4 className="text-sm text-gray-900 mb-0.5" data-id="element-123">{experience.name}</h4>
        <p className="text-xs text-gray-500" data-id="element-124">
          {experience.locked ? 'Bloccata' : `${experience.bottleCount} ${experience.bottleCount === 1 ? 'bottiglia' : 'bottiglie'}`}
        </p>
      </div>
      {isSelected && <div className="w-1 h-8 rounded-full" style={{
      backgroundColor: '#6C083B'
    }} data-id="element-125" />}
    </button>;
}